export enum ImageFormat {
  MobileWebP = 'mobile_webp',
  MobileJpeg = 'mobile_jpeg',
  DesktopWebP = 'desktop_webp',
  DesktopJpeg = 'desktop_jpeg',
  Thumbnail = 'thumbnail',
}
